<template>
     <div id="payment" class="popup-container d-flex align-items-center justify-content-center text-box" :class="{'d-none': !show}" v-if="profile && infos">

        <div class="popup-box bg-white px-3 px-sm-4 px-lg-5 pt-5 pb-4 position-relative popup-payment" v-if="infos.activeAbo">
            <a href="#"
                @click.prevent="hide"
                class="close-popup position-absolute">
                <img src="/images/icons/icon-close-popup.svg" title="Close">
            </a>

            <div class="alert alert-warning mt-3">
                <b>ABO-Upgrade / ABO-Downgrade</b><br><br>
                Bitte kontaktieren Sie uns für Upgrades oder Downgrades via Mail!<br><br>

                <ul class="mt-0 mb-3">
                    <li>Aktuelles ABO: {{  infos.activeAbo.name_short }}</li>
                    <li>Gewünschtes ABO: {{  infos.name }}</li>
                    <li>ABO-ID: {{  infos.activeAbo.id }}</li>
                    <li>Typ: {{  infos.activeAbo.price > infos.price ? 'Downgrade' : 'Upgrade' }}</li>
                </ul>

                <a :href="`mailto:support@dolomitenmarkt.it?subject=${encodeURIComponent(`ABO-Änderung von ${infos.activeAbo.name_short} auf ${infos.name} #${infos.activeAbo.id}`)}`" class="btn btn-bs btn-primary">Kontakt</a>

            </div>

        </div>


        <div class="popup-box bg-white px-3 px-sm-4 px-lg-5 pt-5 pb-4 position-relative popup-payment" v-if="!infos.activeAbo">
            <a href="#"
                @click.prevent="hide"
                class="close-popup position-absolute">
                <img src="/images/icons/icon-close-popup.svg" title="Close">
            </a>
            <a href="#" v-if="step>1 && step<4" @click.prevent="prevStep" class="text-bold d-flex align-items-center tincx-small text-no-underline text-muted hover-opacity step-back position-absolute">
                <svg class="me-1" width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.5 15.5">
                    <path fill="currentcolor" d="M7.75,15.5c4.27,0,7.75-3.48,7.75-7.75S12.02,0,7.75,0,0,3.48,0,7.75s3.48,7.75,7.75,7.75ZM7.75,1.29c3.58,0,6.46,2.88,6.46,6.46s-2.88,6.46-6.46,6.46S1.29,11.33,1.29,7.75,4.17,1.29,7.75,1.29Z"></path>
                    <path fill="currenfntcolor" d="M6.46,10.53c.3.3.7.3.89,0s.3-.7,0-.89l-1.29-1.29h4.77c.4,0,.6-.3.6-.6s-.3-.6-.6-.6h-4.77l1.29-1.29c.3-.3.3-.7,0-.89s-.3-.2-.5-.2-.3,0-.5.2l-2.29,2.29h0c-.1.1-.2.3-.2.5s2.58,2.78,2.58,2.78Z"></path>
                </svg> Zurück </a>
            <form class="form steps-content position-relative">
                <div v-if="step==1" :class="{active: step==1}">

                    <p class="my-0 tincx-h4">Online-Kauf {{  infos.type=='abo' ? 'ABO' : 'Produkt' }}</p>
                    <p>
                        In nur 3 Schritten können Sie den Kauf Ihres gewählten {{  infos.type=='abo' ? 'ABO' : 'Produkt' }} abschließen.
                    </p>

                    <div v-if="infos.entry" class="alert alert-info">
                        Der Kauf betrifft die Anzeige:
                        <b>{{ infos.entry.title }}</b><br><br>
                        Nach Kaufabschluss erhalten Sie eine E-Mail mit weiteren Informationen.
                    </div>

                    <template v-if="false">
                        <p class="tincx-h5">Daten überprüfen</p>
                        <div class="row">
                            <p class="col-12 col-sm-6 col-md-4 mt-0" v-if="profile.private">
                                <strong>Name</strong>
                                <br>{{ profile.lastname }} {{ profile.firstname }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0" v-if="!profile.private">
                                <strong>Firmenname</strong>
                                <br>{{ profile.company_name }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0" v-if="!profile.private">
                                <strong>Anzahl Mitarbeiter</strong>
                                <br>{{ profile.workers }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0">
                                <strong>E-Mail</strong>
                                <br>{{ profile.email }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0">
                                <strong>Straße</strong>
                                <br>{{ profile.street }} {{  profile.street_number }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0">
                                <strong>Ort</strong>
                                <br>{{ profile.postal_code }} {{  profile.city }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0">
                                <strong>Telefonnummer</strong>
                                <br>{{  profile.phone || '-' }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0">
                                <strong>Str.Nr.</strong>
                                <br>{{ profile.tax_id || '-' }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0" v-if="!profile.private">
                                <strong>MwStr.Nr.</strong>
                                <br>{{ profile.vat_id || '-' }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0" v-if="!profile.private">
                                <strong>Empfängerkodex</strong>
                                <br>{{ profile.sdi_code ? profile.sdi_code : '0000000' }}
                            </p>
                            <p class="col-12 col-sm-6 col-md-4 mt-0" v-if="profile.pec">
                                <strong>PEC</strong>
                                <br>{{ profile.pec }}
                            </p>
                        </div>
                        <a href="#" @click.prevent="nextStep" class="tincx-small">Daten ändern</a>
                        <hr class="my-3">

                    </template>

                    <p class="tincx-h4 my-0" v-if="infos.type=='abo'">ABO: {{  infos.name }}</p>
                    <p class="tincx-h4 my-0" v-if="infos.type=='single'">Paket: {{ infos.name }}</p>
                    <ul class="advantages">
                        <li v-for="f in infos.features">{{ f }}</li>
                    </ul>


                    <div class="mt-4">
                        <hr>
                        <p>Im Kommentarfeld können Sie uns Wünsche / Infos mitteilen:</p>
                        <textarea
                            name="comment"
                            placeholder="Kommentar (optional)"
                            rules=""
                            rows="3"
                            v-model="comment"
                            class="mt-2"
                        />
                    </div>

                    <div class="text-right mt-3 d-flex justify-content-between align-items-center">
                        <p class="tincx-h4 my-0" v-if="infos.price==0">kostenlos</p>
                        <p class="tincx-h4 my-0" v-else-if="infos.type=='abo'">{{ $f.number(infos.price) }} € <small>/ Jahr*</small></p>
                        <p class="tincx-h4 my-0" v-else-if="infos.type=='single'">{{ $f.number(infos.price) }} € <small> einmalig*</small></p>
                        <a href="#" class="btn btn-primary btn-bs" @click.prevent="nextStep">Weiter</a>
                    </div>
                    <hr class="my-3">
                    <small class="text-center text-muted d-block mb-3">
                        <template v-if="infos.type=='abo'">
                            *Hier handelt es sich um ein Abo, welches jährlich automatisch erneuert wird.&nbsp;
                            Sie werden 5 Tage vor Erneuerung des ABOs per E-Mail benachrichtigt.
                        </template>
                        <template v-if="infos.type=='single'">
                            *Hier handelt es sich um eine Einzelbestellung und einen einmaligen Kauf.
                        </template>
                        Durch den Kauf stimmen Sie unseren <a target="_blank" href="/nutzungsbedingungen">Nutzungsbedingungen</a> und <a href="/agb" target="_blank">AGB</a> zu. Preise exklusive MwStr.
                    </small>
                </div>


                <div v-if="step==2" :class="{active: step==2}">
                    <p class="my-0 tincx-h4">Online-Kauf {{  infos.type=='abo' ? 'ABO' : 'Produkt' }}</p>
                    <p class="mb-0">Prüfen Sie hier Ihre Firmendaten für den Online-Kauf.</p>
                    <p class="text-muted my-0">Änderungen werden in Ihrem Firmenprofil aktualisiert.</p>
                    <Form
                        ref="formInvoiceData"
                        novalidate
                        :initial-values="profile"
                        @submit="onUpdateProfileData"
                        @invalid-submit="onInvalid"
                        class="form"
                        v-slot="{ errors, values, meta }"
                    >
                        <div class="row-small">
                            <template v-if="profile.private">
                                <div class="tincx-h5 mt-3 mb-0">Vorname / Nachname</div>


                                <div class="col-12 col-sm-6 col-md-12 col-lg-6 mt-2 mt-sm-3">
                                    <div class="form-floating">
                                        <Field
                                            type="text"
                                            name="firstname"
                                            id="firstname"
                                            class="form-control"
                                            :placeholder="`${$t('validation.attributes.firstname')}*`"
                                            rules="required"
                                            :class="{ 'is-invalid': errors.firstname }"
                                        />
                                        <label for="firstname">{{ $t('validation.attributes.firstname') }}</label>
                                        <ErrorMessage as="div" name="firstname" class="invalid-feedback" />
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-12 col-lg-6 mt-2 mt-sm-3">
                                    <div class="form-floating">
                                        <Field
                                            type="text"
                                            name="lastname"
                                            id="lastname"
                                            class="form-control"
                                            :placeholder="`${$t('validation.attributes.lastname')}*`"
                                            rules="required"
                                            :class="{ 'is-invalid': errors.lastname }"
                                        />
                                        <label for="lastname">{{ $t('validation.attributes.lastname') }}</label>
                                        <ErrorMessage as="div" name="lastname" class="invalid-feedback" />
                                    </div>
                                </div>


                                <div class="tincx-h5 mt-3 mb-0">Steuernummer</div>


                                <div class="col-12  mt-2 mt-sm-3">
                                    <div class="form-floating">
                                        <Field
                                            type="text"
                                            name="tax_id"
                                            id="tax_id"
                                            class="form-control"
                                            :placeholder="`${$t('validation.attributes.tax_id')}*`"
                                            rules="required"
                                            :class="{ 'is-invalid': errors.tax_id }"
                                        />
                                        <label for="tax_id">{{ $t('validation.attributes.tax_id') }}</label>
                                        <ErrorMessage as="div" name="tax_id" class="invalid-feedback" />
                                    </div>
                                </div>

                            </template>

                            <template v-else>
                                <div class="tincx-h5 mt-3 mb-0">Firmenbezeichnung</div>


                                <div class="col-12  mt-2 mt-sm-3">
                                    <div class="form-floating">
                                        <Field
                                            type="text"
                                            name="company_name"
                                            id="company_name"
                                            class="form-control"
                                            :placeholder="`${$t('validation.attributes.company_name')}*`"
                                            rules="required"
                                            :class="{ 'is-invalid': errors.company_name }"
                                        />
                                        <label for="company_name">{{ $t('validation.attributes.company_name') }}</label>
                                        <ErrorMessage as="div" name="company_name" class="invalid-feedback" />
                                    </div>
                                </div>

                                <div class="tincx-h5 mt-3 mb-0">Steuernummer / Mehrwertssteuernummer</div>


                                <div class="col-12 col-sm-6 col-md-12 col-lg-6 mt-2 mt-sm-3">
                                    <div class="form-floating">
                                        <Field
                                            type="text"
                                            name="vat_id"
                                            id="vat_id"
                                            class="form-control"
                                            :placeholder="`${$t('validation.attributes.vat_id')}*`"
                                            rules="required"
                                            :class="{ 'is-invalid': errors.vat_id }"
                                        />
                                        <label for="vat_id">{{ $t('validation.attributes.vat_id') }}</label>
                                        <ErrorMessage as="div" name="vat_id" class="invalid-feedback" />
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-12 col-lg-6 mt-2 mt-sm-3">
                                    <div class="form-floating">
                                        <Field
                                            type="text"
                                            name="tax_id"
                                            id="tax_id"
                                            class="form-control"
                                            :placeholder="`${$t('validation.attributes.tax_id')}*`"
                                            rules=""
                                            :class="{ 'is-invalid': errors.tax_id }"
                                        />
                                        <label for="tax_id">{{ $t('validation.attributes.tax_id') }}</label>
                                        <ErrorMessage as="div" name="tax_id" class="invalid-feedback" />
                                    </div>
                                </div>

                                <div class="tincx-h5 mt-3 mb-0">Elektronische RG</div>

                                <div class="col-12 col-sm-6 col-md-12 col-lg-6 mt-2 mt-sm-3">
                                    <div class="form-floating">
                                        <Field
                                            type="text"
                                            name="pec"
                                            id="pec"
                                            class="form-control"
                                            :placeholder="`${$t('validation.attributes.pec')}*`"
                                            rules=""
                                            :class="{ 'is-invalid': errors.pec }"
                                        />
                                        <label for="pec">{{ $t('validation.attributes.pec') }}</label>
                                        <ErrorMessage as="div" name="pec" class="invalid-feedback" />
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-12 col-lg-6 mt-2 mt-sm-3">
                                    <div class="form-floating">
                                        <Field
                                            type="text"
                                            name="sdi_code"
                                            id="sdi_code"
                                            class="form-control"
                                            :placeholder="`${$t('validation.attributes.sdi_code')}*`"
                                            rules=""
                                            :class="{ 'is-invalid': errors.sdi_code }"
                                        />
                                        <label for="sdi_code">{{ $t('validation.attributes.sdi_code') }}</label>
                                        <ErrorMessage as="div" name="sdi_code" class="invalid-feedback" />
                                    </div>
                                </div>

                            </template>


                            <div class="tincx-h5 mt-3 mb-0">Adressdaten</div>


                            <div class="col-12 col-sm-8 col-md-12 col-lg-8 mt-2 mt-sm-3">
                                <div class="form-floating">
                                    <Field
                                        type="text"
                                        name="street"
                                        id="street"
                                        class="form-control"
                                        :placeholder="`${$t('validation.attributes.street')}*`"
                                        rules="required"
                                        :class="{ 'is-invalid': errors.street }"
                                    />
                                    <label for="street">{{ $t('validation.attributes.street') }}</label>
                                    <ErrorMessage as="div" name="street" class="invalid-feedback" />
                                </div>
                            </div>

                            <div class="col-12 col-sm-4 col-md-12 col-lg-4 mt-2 mt-sm-3">
                                <div class="form-floating">
                                    <Field
                                        type="text"
                                        name="street_number"
                                        id="street_number"
                                        class="form-control"
                                        :placeholder="`${$t('validation.attributes.street_number')}*`"
                                        rules="required"
                                        :class="{ 'is-invalid': errors.street_number }"
                                    />
                                    <label for="street_number">{{ $t('validation.attributes.street_number') }}</label>
                                    <ErrorMessage as="div" name="street_number" class="invalid-feedback" />
                                </div>
                            </div>


                            <div class="col-12 col-sm-4 col-md-12 col-lg-4 mt-2 mt-sm-3">
                                <div class="form-floating">
                                    <Field
                                        type="text"
                                        name="postal_code"
                                        id="postal_code"
                                        class="form-control"
                                        :placeholder="`${$t('validation.attributes.postal_code')}*`"
                                        rules="required"
                                        :class="{ 'is-invalid': errors.postal_code }"
                                    />
                                    <label for="postal_code">{{ $t('validation.attributes.postal_code') }}</label>
                                    <ErrorMessage as="div" name="postal_code" class="invalid-feedback" />
                                </div>
                            </div>

                            <div class="col-12 col-sm-8 col-md-12 col-lg-8 mt-2 mt-sm-3">
                                <div class="form-floating">
                                    <Field
                                        type="text"
                                        name="city"
                                        id="city"
                                        class="form-control"
                                        :placeholder="`${$t('validation.attributes.city')}*`"
                                        rules="required"
                                        :class="{ 'is-invalid': errors.city }"
                                    />
                                    <label for="city">{{ $t('validation.attributes.city') }}</label>
                                    <ErrorMessage as="div" name="city" class="invalid-feedback" />
                                </div>
                            </div>


                            <div class="col-12 mt-2 mt-sm-3">
                                <div class="form-floating">
                                    <Field as="select" class="form-control" :placeholder="`${$t('validation.attributes.country')}*`" name="country" rules="required" :class="{'is-invalid': errors.country}">
                                        <option value="" selected>{{ $t('validation.attributes.country') }}</option>
                                        <option value="IT">{{ $t('generic.countries.IT' )}}</option>
                                        <option value="AT">{{ $t('generic.countries.AT' )}}</option>
                                        <option value="DE">{{ $t('generic.countries.DE' )}}</option>
                                        <option value="CH">{{ $t('generic.countries.CH' )}}</option>
                                    </Field>
                                    <label for="country">{{ $t('validation.attributes.country') }}</label>
                                    <ErrorMessage as="div" name="country" class="invalid-feedback" />
                                </div>
                            </div>

                            <p>Falls alle Daten korrekt sind, können Sie mit Klick auf weiter den Kauf fortsetzen.</p>

                            <div class="text-right mt-3">
                                <button
                                    class="btn btn-general btn-bs"
                                    :class="{disabled: (Object.keys(errors).length || !meta.valid) }">
                                    {{ $t('generic.next') }}
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>

                <div v-if="step==3" :class="{active: step==3}">
                    <Form
                        ref="form"
                        novalidate
                        keep-values
                        @submit="onBuy"
                        @invalid-submit="onInvalid"
                        class="form steps-content position-relative"
                        v-slot="{errors, values, meta}"
                    >
                        <p class="tincx-h5 mb-0">Zahlungsart</p>
                        <p class="text-muted mb-3">Bitte wählen Sie die gewünschte Zahlungsart!</p>
                        <div class="row-small justify-content-between">
                            <label class="col-12">
                                <Field class="uk-radio ms-0 me-2 mt-0" type="radio" v-model="paymentType" name="paymentType" value="credit_card" rules="required" />
                                <span>
                                    <img src="/images/icons/icon-payment-mastercard.svg" class="me-1">
                                    <img src="/images/icons/icon-payment-visa.svg" class="me-1">
                                </span>

                                <span class="payment-badge bg-light">Kreditkarte</span>

                            </label>
                            <label v-if="profile.payment_method_bank" class="col-12 mt-4">
                                <Field class="uk-radio ms-0 me-2 mt-0" type="radio" v-model="paymentType" name="paymentType" value="bank_transfer" rules="required" />
                                <span class="payment-badge bg-light">Überweisung / Rechnung</span>
                            </label>
                        </div>

                        <ErrorMessage
                            as="div"
                            v-if="errors.paymentType"
                            name="paymentType"
                            class="invalid-feedback d-block mt-3" />
                        <div v-else class="mt-3">
                            {{  $t(`billingAbo.popup.productPayment.payment_type_info_${paymentType}`) }}
                        </div>

                        <hr class="my-3">
                        <p class="tincx-h4 my-0" v-if="infos.type=='abo'">Ihr ABO: {{  infos.name }}</p>
                        <p class="tincx-h4 my-0" v-if="infos.type=='single'">Ihr Paket: {{ infos.name }}</p>
                        <ul class="advantages">
                            <li v-for="f in infos.features">{{ f }}</li>
                        </ul>
                        <div class="text-right mt-3 d-flex justify-content-between align-items-center">
                            <p class="tincx-h4 my-0" v-if="infos.price==0">kostenlos</p>
                            <p class=" my-0" v-else-if="infos.type=='abo'">{{ $f.number(infos.price) }} € <small>/ Jahr</small></p>
                            <p class="my-0" v-else-if="infos.type=='single'">{{ $f.number(infos.price) }} € <small> einmalig</small></p>
                        </div>
                        <p class="mt-0 pt-0"><span class="tincx-h4">{{  $f.price(infos.price_with_vat) }} €</span> inkl. {{ infos.vat_percent }}% MwStr.</p>


                        <div class="col-12 mt-3">
                            <div class="position-relative">
                                <label class="d-flex align-items-center me-2 text-small">
                                    <Field type="checkbox" required :value="true" rules="required" name="usage" />
                                    <span v-html="$t('fe.application.usage_text', { link: `* [<a target='_blank' href='/nutzungsbedingungen'>${$t('fe.application.link')}</a>]`, linkAgb: `* [<a target='_blank' href='/agb'>${$t('fe.application.link')}</a>]` })"></span>
                                </label>
                                <ErrorMessage
                                    as="div"
                                    v-if="errors.usage"
                                    name="usage"
                                    class="invalid-feedback d-block" />
                            </div>
                        </div>


                        <div class="col-12 mt-3">
                            <div class="position-relative">
                                <label class="d-flex align-items-center me-2 text-small">
                                    <Field type="checkbox" required :value="true" rules="required" name="buyConditions" />
                                    <span v-html="$t(infos.type=='abo' ? 'fe.application.buy_abo_text' : 'fe.application.buy_single_text', { link: `* [<a target='_blank' href='/nutzungsbedingungen'>${$t('fe.application.link')}</a>]`, linkAgb: `* [<a target='_blank' href='/agb'>${$t('fe.application.link')}</a>]` })"></span>
                                </label>
                                <ErrorMessage
                                    as="div"
                                    v-if="errors.buyConditions"
                                    name="buyConditions"
                                    class="invalid-feedback d-block" />
                            </div>
                        </div>


                        <div class="mt-3 mb-4">
                            <button
                                :class="{disabled: Object.keys(errors).length || !meta.valid || !canBuy }"
                                class="btn btn-primary btn-large btn-te  d-inline-flex align-items-center"
                                :data-badge="canBuy ? null : 'Bitte wählen Sie eine Zahlungsart aus'"
                            >
                                Zahlungspflichtig kaufen <svg class="ms-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.8 20.8">
                                    <path fill="#FFFFFF" d="M10.4,0C4.7,0,0,4.7,0,10.4s4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4v0C20.8,4.7,16.1,0,10.4,0z M10.4,18.8
    C5.8,18.8,2,15,2,10.4C2,5.8,5.8,2,10.4,2s8.4,3.8,8.4,8.4C18.8,15,15,18.8,10.4,18.8z"></path>
                                    <path fill="#FFFFFF" d="M15.2,9.7C15.2,9.6,15.2,9.6,15.2,9.7l-3.1-3.1c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l1.4,1.4H6.2
    c-0.6,0-1,0.4-1,1s0.4,1,1,1h6l-1.4,1.4c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l3-3c0,0,0,0,0-0.1
    c0.2-0.2,0.3-0.4,0.3-0.7C15.6,10.1,15.5,9.8,15.2,9.7z"></path>
                                </svg>
                            </button>
                        </div>

                        <hr class="my-3">
                    </Form>
                </div>
                <div v-if="step==4 && successInfo" :class="{active: step==4}" class="pb-3">
                    <p class="my-0 tincx-h4">{{ successInfo.title }}</p>
                    <p v-html="successInfo.description"></p>
                    <a v-for="btn in successInfo.buttons" :href="btn.url" :class="btn.class" class="col-12 col-xs-auto btn btn-bs me-1">{{ btn.name }}</a>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import emitter from '../plugins/mitt';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { Form, Field, ErrorMessage } from 'vee-validate';

export default {
    name: 'ProductPayment',
    components: {
        Form,
        Field,
        ErrorMessage
    },
    inject: ['$t', '$f'],
    mounted: async function () {
        this.loadData()
        emitter.on('product-payment-infos', (val) => {
            this.infos = val
        })
        emitter.on('popup', (val) => {
            this.show = val=='product-payment' ? true : false
            this.step = 1
            this.comment = null
            this.paymentType = null
        })
        emitter.on('disableAbo', (data) => {
            this.disableAbo(data)
        })
        //this.show = true
    },
    computed: {
        currentUrl: function() {
            let url = window.location.href
            if(this.infos) {
                if(url.match(/\?/)) {
                    url = url + '&product-code='+this.infos.code
                } else {
                    url = url + '?product-code='+this.infos.code
                }
            }
            return url
        },
        canBuy: function() {
            return this.paymentType ? true : false
        }
    },
    watch: {
        step: function() {
            document.getElementsByClassName('popup-payment')[0].scrollTop = 0
        },
        profile: function() {
            if(!this.profile.payment_method_bank) {
                this.paymentType = 'credit_card'
            }
        }
    },
    methods: {
        hide: function() {
            if(this.step==4 && window.location.pathname.match(/^\/buy\//)) {
                window.location.reload()
            }
            emitter.emit('popup', false)
        },
        onUpdateProfileData: function (values) {
            Swal.fire({
                text: this.$t('generic.loading'),
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            axios
                .post('/api/profile', { ...values, source: 'buy' })
                .then((response) => {
                    console.log(response)
                    if (response.data.error) {
                        Swal.fire(this.$t('generic.error'), response.data.error, 'error')
                        return
                    }

                    Swal.close()
                    this.loadData()
                    this.step++
                })
                .catch((error) => {
                    console.log(error)
                    if (error.status == 422) {
                        var errors = error.response.data.errors
                        var errorBag = {}
                        for (var field in errors) {
                            errorBag[field] = errors[field].join(', ')
                        }
                        this.$refs.formInvoiceData.setErrors(errorBag)

                        let html =
                            '<ul>' +
                            Object.values(errorBag)
                                .map((e) => '<li>' + e + '</li>')
                                .join('') +
                            '</ul>'
                        Swal.fire({
                            title: this.$t('generic.error'),
                            icon: 'error',
                            html: html,
                        })
                        return
                    }
                    Swal.fire(this.$t('generic.error'), this.$t('generic.error_try_again_later'), 'error')
                })
        },
        nextStep: function() {
            if(this.step==1) {
                if(this.profile.billing_infos_ready) {
            //        this.step++
                }
            }

            if(this.step==4) {
                return
            }
            this.step++
        },
        prevStep: function() {
            if(this.step==4) {
                return
            }
            this.step--
        },
        onInvalid: function({values, errors, results}) {
            let html = '<ul>'+Object.values(errors).map(e => '<li>'+e+'</li>').join('')+'</ul>'
            Swal.fire({
                title: this.$t('generic.error'),
                html: html,
                icon: 'error'
            });
        },
        onBuy: function() {
            Swal.fire({
                title: this.$t('popup.product_payment.title'),
                text: this.$t('popup.product_payment.on_submit'),
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            var search = window.location.search ? new URLSearchParams(window.location.search) : null
            var backUrl = search ? search.get('back') : null


            let values = {
                form: this.$refs.form.values,
                profile: this.profile,
                infos: this.infos,
                paymentType: this.paymentType,
                url: window.location.href,
                urlBack: backUrl,
                section: this.infos.section,
                entry: this.infos.entry,
                comment: this.comment
            }

            axios
                .post('/api/buy', { ...values })
                .then((response) => {
                    console.log(response)
                    if (response.data.error) {
                        Swal.fire(this.$t('generic.error'), response.data.error, 'error')
                        return
                    }

                    if(response.data.redirect) {
                        window.location.href = response.data.redirect
                        return
                    }

                    Swal.close()
                    this.step = 4
                    this.successInfo = response.data.success
                })
                .catch((error) => {
                    console.log(error)
                    if (error.status == 422) {
                        var errors = error.response.data.errors
                        var errorBag = {}
                        for (var field in errors) {
                            errorBag[field] = errors[field].join(', ')
                        }
                        //this.$refs.form.setErrors(errorBag)

                        let html =
                            '<ul>' +
                            Object.values(errorBag)
                                .map((e) => '<li>' + e + '</li>')
                                .join('') +
                            '</ul>'
                        Swal.fire({
                            title: this.$t('generic.error'),
                            icon: 'error',
                            html: html,
                        })
                        return
                    }
                    Swal.fire(this.$t('generic.error'), this.$t('generic.error_try_again_later'), 'error')
                })
        },
        loadData: function () {
            if (this.loading) return
            this.loading = true
            axios
                .get('/api/profile')
                .then(async (response) => {
                    this.loading = false

                    this.profile = {...response.data}
                    /*setTimeout(() => {
                        if (this.$refs && this.$refs.form) {
                            this.$refs.form.setValues(this.data)
                        }
                    }, 100)*/
                })
                .catch((error) => {
                    this.loading = false
                    console.log(error)
                    Swal.fire('Fehler', this.$t('generic.error_loading'), 'error')
                })
        },


        disableAbo: function(data) {
            var terminateDate = data.terminateDate
            var activate = data.aboAction == 'activate'
            Swal.fire({
                title: activate ? "ABO aktivieren" : "ABO deaktivieren",
                html: activate ? "Möchten Sie die Automatische Erneuerung Ihres ABOs am "+terminateDate+" wieder aktiviern?" : "Ihr ABO läuft am "+terminateDate+" aus.<br><br>Möchten Sie Ihr ABO wirklich kündigen und zur nächsten Fälligkeit nicht mehr automatisch erneuren?<br><br>Bis zum "+terminateDate+" können Sie das ABO weiterhin nutzen.",
                showDenyButton: true,
                showConfirmButton: false,
                showCancelButton: true,
                denyButtonText: activate ? "Ja, ABO-Erneuerung aktivieren" : "Ja, Verlängerung deaktivieren",
                denyButtonColor: activate ? 'green' : 'red',
                cancelButtonText: `Abbrechen`
                }).then((result) => {
                    if (result.isDenied) {
                        Swal.fire({
                            text: this.$t('generic.loading'),
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading()
                            },
                        });
                        axios
                            .post('/api/buy/terminate', { ...data })
                            .then((response) => {
                                console.log(response)
                                if (response.data.error) {
                                    Swal.fire(this.$t('generic.error'), response.data.error, 'error')
                                    return
                                }

                                if(response.data.redirect) {
                                    window.location.href = response.data.redirect
                                    return
                                }

                                Swal.fire({
                                    title: response.data.title,
                                    text: response.data.message,
                                    icon: 'success',
                                    didClose: () => {
                                        window.location.reload()
                                    }
                                })
                            })
                            .catch((error) => {
                                console.log(error)
                                Swal.fire(this.$t('generic.error'), this.$t('generic.error_try_again_later'), 'error')
                            })
                    }
                });
        }

    },
    data() {
        return {
            show: false,
            profile: null,
            infos: null,
            loading: false,
            successInfo: null,
            comment: null,
            step: 1,
            paymentType: null,
        }
    },
}
</script>
